import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.scss';

interface NoResultsMessageProps {
  className?: string;
}

const NoResultsMessage = ({ className }: NoResultsMessageProps) => {
  return <div className={clsx(styles.noContentMessage, 'serif', className)}>No results found!</div>;
};

export default NoResultsMessage;
